import instance from '@/utils/axios';

/**
 *  日志记录
 * @param {*} data
 * @returns
 */
export function logInfoServer(data) {
  return instance.post('airDefense/emergencyLog/findList', data);
}
